import CONFIG from '@/common/config'

export default function(nameObj) {
  if (!nameObj) return ''
  if (typeof nameObj === 'string') return nameObj
  const lang = localStorage.getItem(CONFIG.LOCALE_KEY_LANG) || CONFIG.DEFAULT_LANG
  const isCN = lang.indexOf('zh') > -1
  return isCN ? nameObj[CONFIG.API_LANGS.zh] : nameObj[CONFIG.API_LANGS.en]
}
